import { Box } from '@chakra-ui/react';
import { Alert } from '@ui/components/Alert';

export type QueryNoResultsProps = {
  title?: string;
  description?: string;
};

export function QueryNoResults({ title, description }: QueryNoResultsProps) {
  return (
    <Box padding={6} width="100%">
      <Alert
        status="info"
        title={title || 'No results found'}
        description={description}
      />
    </Box>
  );
}
